//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Barthel',
  data () {
    return {
      form: {
        feeding: '',
        transfers: '',
        cleaning: '',
        toilet: '',
        bathing: '',
        mobility: '',
        stairs: '',
        dressing: '',
        bowels: '',
        bladder: '',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', shortName: '需要较多帮助', name: '需要较多帮助'},
        {value: '5', shortName: '需要部分帮助', name: '需要部分帮助'},
        {value: '10', shortName: '独立完成', name: '独立完成'}
      ],
      dataList2: [
        {value: '0', shortName: '完全依赖', name: '完全依赖'},
        {value: '5', shortName: '需要较多帮助', name: '需要较多帮助'},
        {value: '10', shortName: '需要部分帮助', name: '需要部分帮助'},
        {value: '15', shortName: '独立完成', name: '独立完成'}
      ],
      dataList3: [
        {value: '0', shortName: '需要部分帮助', name: '需要部分帮助'},
        {value: '5', shortName: '独立完成', name: '独立完成'}
      ],
      dataList4: [
        {value: '0', shortName: '需要较多帮助', name: '需要较多帮助'},
        {value: '5', shortName: '需要部分帮助', name: '需要部分帮助'},
        {value: '10', shortName: '独立完成', name: '独立完成'}
      ],
      dataList5: [
        {value: '0', shortName: '需要部分帮助', name: '需要部分帮助'},
        {value: '5', shortName: '独立完成', name: '独立完成'}
      ],
      dataList6: [
        {value: '0', shortName: '完全依赖', name: '完全依赖'},
        {value: '5', shortName: '需要较多帮助', name: '需要较多帮助（依赖搀扶，或坐着轮椅自行移动）'},
        {value: '10', shortName: '需要部分帮助', name: '需要部分帮助（搀扶，或使用拐杖、助行器）'},
        {value: '15', shortName: '独立完成', name: '独立完成'}
      ],
      dataList7: [
        {value: '0', shortName: '需要较多帮助', name: '需要较多帮助'},
        {value: '5', shortName: '需要部分帮助', name: '需要部分帮助'},
        {value: '10', shortName: '独立完成', name: '独立完成'}
      ],
      dataList8: [
        {value: '0', shortName: '需要较多帮助', name: '需要较多帮助'},
        {value: '5', shortName: '需要部分帮助', name: '需要部分帮助（能独立披上外套，但需帮助系扣、拉链）'},
        {value: '10', shortName: '独立完成', name: '独立完成'}
      ],
      dataList9: [
        {value: '0', shortName: '需要较多帮助', name: '需要较多帮助（失控）'},
        {value: '5', shortName: '需要部分帮助', name: '需要部分帮助（每周＜1次失控）'},
        {value: '10', shortName: '独立完成', name: '独立完成'}
      ],
      dataList10: [
        {value: '0', shortName: '需要较多帮助', name: '需要较多帮助（失控）'},
        {value: '5', shortName: '需要部分帮助', name: '需要部分帮助（每天＜1次失控）'},
        {value: '10', shortName: '独立完成', name: '独立完成'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (form[key] == '---') {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Nurse/Barthel.vue